import { ReactComponent as QUOTE } from "../../assets/quote.svg"
import { useAccessibility } from "../../context/AccessibilityContext"
import BaseRichtext from "./BaseRichtext"
import "../../style/colors.css"

type BaseQuoteTextType = {
    text: string
    author?: string
    isQuoteWhite?: boolean
}

export default function BaseQuoteText(props: BaseQuoteTextType) {
    const { getCursorPointerClass } = useAccessibility()

    return (
        <div className=" text-center md:max-w-2xl  lg:max-w-3xl mx-auto flex flex-col items-center justify-center w-full ">
            <p className="relative">
                <QUOTE className={`w-6 h-6 absolute -top-6 md:-left-8 md:-top-2 ${getCursorPointerClass()} ${props.isQuoteWhite && "fill-accent"}`} />
                <BaseRichtext content={props.text} classProps={`!text-lg !font-semibold ${props.isQuoteWhite && "text-accent"}`} />
            </p>
            <BaseRichtext content={props.author} classProps={`${props.isQuoteWhite && "text-accent"}`} />
        </div>
    )
}
